/**
 * HeatProfilePage - Heat Profile Page with Modern Layout
 *
 * Sub-tabs (Heat Profile, Test Repository, DCAL Generator, Coil Configurator), then Heat Profile content.
 */

import React from 'react';
import HeatProfile from '../../components/HeatProfile';
import TechnicalSubTabs from './TechnicalSubTabs';
import './HeatProfilePage.css';

const HeatProfilePage = () => (
    <div className="heat-profile-page">
        <TechnicalSubTabs />
        <div className="heat-profile-content-wrapper">
            <HeatProfile />
        </div>
    </div>
);

export default HeatProfilePage;
